import React, { useEffect, useState } from "react";
import { hitApi } from "../utils/apiCall";
import def from "./assets/default.png";
import sunrise from "./assets/sunrise.png";
import afternoon from "./assets/afternoon.png";
import sunset from "./assets/sunset.png";
import {
    Visibility,
    VisibilityOff,
} from "@mui/icons-material";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
    const [profile, setProfile] = useState(null);
    const [showOtpBox, setShowOtpBox] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    const [otp, setOtp] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();

    const getGreeting = () => {
        const currentHour = new Date().getHours();
        if (currentHour < 12) return ["Morning", sunrise];
        if (currentHour < 15) return ["Afternoon", afternoon];
        return ["Evening", sunset];
    };

    useEffect(() => {
        fetchProfile();

    }, []);

    async function fetchProfile() {
        const fd = new FormData();

        fd.append("authToken", localStorage.getItem("authToken") || "");
        fd.append("token", localStorage.getItem("token") || "");
        fd.append("id", localStorage.getItem("staffId") || "");

        const res = await hitApi(
            "employee/employeeCurl",
            "getDetailsForUpdate",
            fd
        );
        console.log("profile res", res);

        if (res?.success && res?.data?.length > 0) {
            setProfile(res.data[0]);
        }
    }

    async function getOTP() {
        const fd = new FormData();

        fd.append("authToken", localStorage.getItem("authToken") || "");
        fd.append("token", localStorage.getItem("token") || "");

        const res = await hitApi(
            "employee/employeeCurl",
            "sendForgotOTP",
            fd
        );

        console.log("otp res", res);

        if (res?.success) {
            toast.success(res.message);
            setShowOtpBox(true);
        } else {
            toast.error("Failed to send OTP");
        }
    }

    async function verifyOTP() {
        if (!otp) {
            toast.error("Enter OTP");
            return;
        }

        const fd = new FormData();

        fd.append("authToken", localStorage.getItem("authToken") || "");
        fd.append("token", localStorage.getItem("token") || "");
        fd.append("otp", otp);

        const res = await hitApi(
            "employee/employeeCurl",
            "verifyForgotOTP",
            fd
        );

        console.log("verify res", res);

        if (res?.success) {
            toast.success(res.message);
            setOtpVerified(true);
            setShowOtpBox(false);
        } else {
            toast.error("Invalid OTP");
        }
    }

    async function updatePassword() {
        if (!password || !confirmPassword) {
            toast.error("Please fill all fields");
            return;
        }

        if (password !== confirmPassword) {
            toast.error("Passwords do not match");
            return;
        }

        const fd = new FormData();

        fd.append("authToken", localStorage.getItem("authToken") || "");
        fd.append("token", localStorage.getItem("token") || "");
        fd.append("password", password);
        fd.append("confirm_password", confirmPassword);

        const res = await hitApi(
            "employee/employeeCurl",
            "changeForgotPassword",
            fd
        );

        console.log("password update", res);

        if (res?.success) {
            toast.success(res.message || "Password Updated Successfully");

            setPassword("");
            setConfirmPassword("");
            setOtpVerified(false);
        } else {
            toast.error("Failed to update password")
        }
    }

    if (!profile) {
        return (
            <div className="container mt-5 text-center">
                Loading Profile...
            </div>
        );
    }

    return (
        <div className="page-content-wrapper py-3">
            <div className="container">

                <div className="d-flex align-items-center mb-3 mt-4">
                    <button
                        className="btn btn-outline-secondary rounded-pill"
                        onClick={() => navigate(-1)}
                    >
                        ← Back
                    </button>
                </div>
                {/* Profile Details */}
                <div className="card mt-3 rounded-4 shadow-sm">
                    <div className="card-body">
                        <h5 className="mb-3">Profile Details</h5>

                        <div className="row">
                            <div className="col-6 mb-3">
                                <small className="text-muted">Name</small>
                                <div>{profile.name || "-"}</div>
                            </div>
                            <div className="col-6 mb-3">
                                <small className="text-muted">Mobile</small>
                                <div>{profile.mobileno || "-"}</div>
                            </div>

                            <div className="col-6 mb-3">
                                <small className="text-muted">Email</small>
                                <div>{profile.email || "-"}</div>
                            </div>

                            <div className="col-6 mb-3">
                                <small className="text-muted">Gender</small>
                                <div>{profile.sex || "-"}</div>
                            </div>


                        </div>
                    </div>
                </div>
              
                <div className="card mt-3 rounded-4 shadow-sm">
                    <div className="card-body">

                        {!showOtpBox && !otpVerified && (
                            <button
                                className="btn btn-primary w-100"
                                onClick={getOTP}
                            >
                                Update Password
                            </button>
                        )}

                        {showOtpBox && (
                            <>
                                <div className="mb-3">
                                    <label className="form-label">Enter OTP</label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        value={otp}
                                        onChange={(e) => setOtp(e.target.value)}
                                        placeholder="Enter OTP"
                                    />
                                </div>

                                <div className="d-flex gap-2">
                                    <button
                                        className="btn btn-success flex-fill"
                                        onClick={verifyOTP}
                                    >
                                        Verify
                                    </button>

                                    <button
                                        className="btn btn-secondary flex-fill"
                                        onClick={() => {
                                            setShowOtpBox(false);
                                            setOtp("");
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </>
                        )}

                        {otpVerified && (
                            <>
                                <div className="mb-3">
                                    <label className="form-label">
                                        Enter New Password
                                    </label>

                                    <div className="input-group">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            className="form-control"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />

                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            onClick={() =>
                                                setShowPassword(!showPassword)
                                            }
                                        >
                                            {showPassword ? (
                                                <VisibilityOff />
                                            ) : (
                                                <Visibility />
                                            )}
                                        </button>
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Confirm Password
                                    </label>

                                    <div className="input-group">
                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            className="form-control"
                                            value={confirmPassword}
                                            onChange={(e) =>
                                                setConfirmPassword(e.target.value)
                                            }
                                        />

                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            onClick={() =>
                                                setShowConfirmPassword(
                                                    !showConfirmPassword
                                                )
                                            }
                                        >
                                            {showConfirmPassword ? (
                                                <VisibilityOff />
                                            ) : (
                                                <Visibility />
                                            )}
                                        </button>
                                    </div>
                                </div>

                                <button
                                    className="btn btn-primary w-100"
                                    onClick={updatePassword}
                                >
                                    Update Password
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;